import { render, staticRenderFns } from "./dashboard-skeleton.vue?vue&type=template&id=535540e1"
var script = {}
import style0 from "./dashboard-skeleton.vue?vue&type=style&index=0&id=535540e1&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports